import { useEffect, useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Hook to fetch editable page content with fallback defaults.
 * Returns a getter `t(key, fallback)` that resolves the source string
 * and then runs it through the active language translator.
 */
export const usePageContent = (pageId) => {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);
  const { t: translate } = useLanguage();

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/pages/${pageId}`);
        setContent(data.content || {});
      } catch (e) {
        setContent({});
      } finally {
        setLoaded(true);
      }
    };
    fetchContent();
  }, [pageId]);

  const t = (key, fallback) => {
    const val = content[key];
    const source = val !== undefined && val !== '' ? val : fallback;
    return translate(source);
  };

  return { content, t, loaded };
};
